module.exports = __webpack_public_path__ + "static/img/tcqn6.ba5f9c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/tcqn6.png
// module id = 385
// module chunks = 0